module.exports = {
    zh: {
        courseName: '课程名称',
        courseSeries: '课程系列',
        courseFile: '课程文件',
        upload: '上传',
        fileName: '文件名称',
        effectiveDate: '有效期',
        cancel: '取消',
        confirm: '确定',
        clickUpload: '点此上传',
        operation: '操作',
        distribution: '分配',
        distributionCourse: '分配课程',
        selectObject: '选择分配对象',
        selectCourse: '选择课程',
        courseVisitEndDate: '课程访问失效日期',
        preservation: '保存',
        date: '日期',
        search: '搜索',
        reset:'重置',
        hasDistributionGarden: '已分配园所',
        hasDistributionClass: '已分配班级',
        delete:'删除',
        check: '查看',
        garden: '园所',
        class: '班级',
        selectFile: '选择文件',
        fileTitle: '文件标题',
        modify: '修改',
        fullScreen: '全屏',
        print: '打印',
        rotating: '旋转',
        courseQACenter: '课程答疑中心',
        courseResourceCenter: '备课资源中心',
        comments: '评论',
        latest: '最新',
        reply: '回复',
        packUp: '收起',
        viewMore: '查看更多',
        blackWhite: "黑白",
        color: "彩色"
    },
    en: {
        courseName: 'Curriculum',
        courseSeries: 'Series',
        courseFile: 'Course file',
        upload: 'Upload',
        fileName: 'Lesson Plan',
        effectiveDate: 'The period of validity',
        cancel: 'cancel',
        confirm: 'confirm',
        clickUpload: 'Click on the upload',
        operation: 'operation',
        distribution: 'Distribution',
        distributionCourse: 'Distribution course',
        selectObject: 'Select the allocated object',
        selectCourse: 'Select course',
        courseVisitEndDate: 'Course access expiry date',
        preservation: 'preservation',
        date: 'date',
        search: 'search',
        reset:'reset',
        hasDistributionGarden: 'School',
        hasDistributionClass: 'Class',
        delete: 'delete',
        check:'check',
        garden: 'garden',
        class: 'class',
        selectFile: 'Select the file',
        fileTitle: 'The file header',
        modify: 'update',
        fullScreen: 'Full screen',
        print: 'print',
        rotating: 'rotating',
        courseQACenter: 'Course q&a center',
        courseResourceCenter: 'Lesson preparation resource center',
        comments: 'comments',
        latest: 'latest',
        reply: 'reply',
        packUp: 'Pack up',
        viewMore: 'To view more',
        blackWhite: "Black & White",
        color: "Color"

    }
}


// WEBPACK FOOTER //
// ./src/components/i18n/lang/courseManagement.js